module.exports = __webpack_public_path__ + "img/My-buddy_rBo.jpg";